import { tv } from "../../variants/tv.js";
const sharedRootClasses = "after:absolute after:left-0 after:h-[calc(var(--gap)+1px)] after:w-full after:content-[''] data-[expanded]:[transform:translateX(var(--toast-swipe-movement-x))_translateY(calc(var(--offset-y)))]";
const bottomRootClasses = `[--offset-y:calc(var(--toast-offset-y)*-1+calc(var(--toast-index)*var(--gap)*-1)+var(--toast-swipe-movement-y))] bottom-0 origin-bottom [transform:translateX(var(--toast-swipe-movement-x))_translateY(calc(var(--toast-swipe-movement-y)-(var(--toast-index)*var(--peek))-(var(--shrink)*var(--height))))_scale(var(--scale))] after:top-full data-[starting-style]:[transform:translateY(150%)] [&[data-ending-style]:not([data-limited]):not([data-swipe-direction])]:[transform:translateY(150%)] ${sharedRootClasses}`;
const topRootClasses = `[--offset-y:calc(var(--toast-offset-y)+calc(var(--toast-index)*var(--gap))+var(--toast-swipe-movement-y))] top-0 origin-top [transform:translateX(var(--toast-swipe-movement-x))_translateY(calc(var(--toast-swipe-movement-y)+(var(--toast-index)*var(--peek))+(var(--shrink)*var(--height))))_scale(var(--scale))] after:bottom-full data-[starting-style]:[transform:translateY(-150%)] [&[data-ending-style]:not([data-limited]):not([data-swipe-direction])]:[transform:translateY(-150%)] ${sharedRootClasses}`;
const toastVariants = tv({
    slots: {
        viewportSlot: 'fixed z-10 mx-auto flex w-[250px] outline-none sm:w-[300px]',
        anchoredViewportSlot: 'absolute z-10 flex w-[250px] outline-none sm:w-[300px]',
        rootSlot: 'absolute right-0 left-auto z-[calc(1000-var(--toast-index))] mr-0 box-border h-[var(--height)] w-full cursor-default rounded-lg border-1 bg-clip-padding shadow-lg select-none [--gap:0.75rem] [--height:var(--toast-frontmost-height,var(--toast-height))] [--peek:0.75rem] [--scale:calc(max(0,1-(var(--toast-index)*0.1)))] [--shrink:calc(1-var(--scale))] [transition:transform_0.5s_cubic-bezier(0.22,1,0.36,1),opacity_0.5s,height_0.15s] data-[ending-style]:opacity-0 data-[expanded]:h-[var(--toast-height)] data-[limited]:opacity-0 data-[ending-style]:data-[swipe-direction=down]:[transform:translateY(calc(var(--toast-swipe-movement-y)+150%))] data-[expanded]:data-[ending-style]:data-[swipe-direction=down]:[transform:translateY(calc(var(--toast-swipe-movement-y)+150%))] data-[ending-style]:data-[swipe-direction=left]:[transform:translateX(calc(var(--toast-swipe-movement-x)-150%))_translateY(var(--offset-y))] data-[expanded]:data-[ending-style]:data-[swipe-direction=left]:[transform:translateX(calc(var(--toast-swipe-movement-x)-150%))_translateY(var(--offset-y))] data-[ending-style]:data-[swipe-direction=right]:[transform:translateX(calc(var(--toast-swipe-movement-x)+150%))_translateY(var(--offset-y))] data-[expanded]:data-[ending-style]:data-[swipe-direction=right]:[transform:translateX(calc(var(--toast-swipe-movement-x)+150%))_translateY(var(--offset-y))] data-[ending-style]:data-[swipe-direction=up]:[transform:translateY(calc(var(--toast-swipe-movement-y)-150%))] data-[expanded]:data-[ending-style]:data-[swipe-direction=up]:[transform:translateY(calc(var(--toast-swipe-movement-y)-150%))]',
        contentSlot: 'flex w-full items-start gap-3 overflow-hidden px-4 py-3 transition-opacity [transition-duration:250ms] data-[behind]:pointer-events-none data-[behind]:opacity-0 data-[expanded]:pointer-events-auto data-[expanded]:opacity-100',
        iconSlot: 'flex shrink-0 items-center justify-center',
        titleSlot: '',
        descriptionSlot: '',
        actionSlot: 'shrink-0 self-end',
        closeSlot: 'absolute top-2 right-2',
        bodySlot: 'flex min-w-0 flex-1 flex-col gap-1'
    },
    variants: {
        palette: {
            neutral: {},
            info: {},
            success: {},
            caution: {},
            error: {}
        },
        emphasis: {
            regular: {},
            medium: {},
            bold: {}
        },
        position: {
            bottomRight: {
                viewportSlot: 'top-auto right-[1rem] bottom-[1rem] left-auto sm:right-[2rem] sm:bottom-[2rem]',
                rootSlot: bottomRootClasses
            },
            bottom: {
                viewportSlot: 'top-auto right-auto bottom-[1rem] left-1/2 -translate-x-1/2 sm:bottom-[2rem]',
                rootSlot: bottomRootClasses
            },
            bottomLeft: {
                viewportSlot: 'top-auto right-auto bottom-[1rem] left-[1rem] sm:bottom-[2rem] sm:left-[2rem]',
                rootSlot: bottomRootClasses
            },
            topRight: {
                viewportSlot: 'top-[1rem] right-[1rem] bottom-auto left-auto sm:top-[2rem] sm:right-[2rem]',
                rootSlot: topRootClasses
            },
            top: {
                viewportSlot: 'top-[1rem] right-auto bottom-auto left-1/2 -translate-x-1/2 sm:top-[2rem]',
                rootSlot: topRootClasses
            },
            topLeft: {
                viewportSlot: 'top-[1rem] right-auto bottom-auto left-[1rem] sm:top-[2rem] sm:left-[2rem]',
                rootSlot: topRootClasses
            }
        },
        side: {
            bottom: {
                anchoredViewportSlot: 'top-full mt-2'
            },
            top: {
                anchoredViewportSlot: 'bottom-full mb-2'
            }
        },
        align: {
            start: {
                anchoredViewportSlot: 'left-0'
            },
            center: {
                anchoredViewportSlot: 'left-1/2 -translate-x-1/2'
            },
            end: {
                anchoredViewportSlot: 'right-0'
            }
        }
    },
    compoundVariants: [
        {
            palette: 'neutral',
            emphasis: 'regular',
            class: {
                rootSlot: 'border-neutral-4 bg-neutral-1 text-neutral-13',
                iconSlot: '*:text-neutral-8'
            }
        },
        {
            palette: 'info',
            emphasis: 'regular',
            class: {
                rootSlot: 'border-primary-4 bg-primary-1 text-primary-13',
                iconSlot: '*:text-primary-8'
            }
        },
        {
            palette: 'success',
            emphasis: 'regular',
            class: {
                rootSlot: 'border-success-4 bg-success-1 text-success-13',
                iconSlot: '*:text-success-8'
            }
        },
        {
            palette: 'caution',
            emphasis: 'regular',
            class: {
                rootSlot: 'border-caution-4 bg-caution-1 text-caution-13',
                iconSlot: '*:text-caution-9'
            }
        },
        {
            palette: 'error',
            emphasis: 'regular',
            class: {
                rootSlot: 'border-error-4 bg-error-1 text-error-13',
                iconSlot: '*:text-error-8'
            }
        },
        {
            palette: 'neutral',
            emphasis: 'medium',
            class: {
                rootSlot: 'border-neutral-2 bg-neutral-2 text-neutral-13',
                iconSlot: '*:text-neutral-10'
            }
        },
        {
            palette: 'info',
            emphasis: 'medium',
            class: {
                rootSlot: 'border-primary-3 bg-primary-3 text-primary-13',
                iconSlot: '*:text-primary-8'
            }
        },
        {
            palette: 'success',
            emphasis: 'medium',
            class: {
                rootSlot: 'border-success-3 bg-success-3 text-success-13',
                iconSlot: '*:text-success-8'
            }
        },
        {
            palette: 'caution',
            emphasis: 'medium',
            class: {
                rootSlot: 'border-caution-3 bg-caution-3 text-caution-13',
                iconSlot: '*:text-caution-9'
            }
        },
        {
            palette: 'error',
            emphasis: 'medium',
            class: {
                rootSlot: 'border-error-3 bg-error-3 text-error-13',
                iconSlot: '*:text-error-8'
            }
        },
        {
            palette: 'neutral',
            emphasis: 'bold',
            class: {
                rootSlot: 'border-neutral-10 bg-neutral-10 text-neutral-1',
                iconSlot: '*:text-neutral-1'
            }
        },
        {
            palette: 'info',
            emphasis: 'bold',
            class: {
                rootSlot: 'border-primary-9 bg-primary-9 text-primary-1',
                iconSlot: '*:text-primary-1'
            }
        },
        {
            palette: 'success',
            emphasis: 'bold',
            class: {
                rootSlot: 'border-success-9 bg-success-9 text-success-1',
                iconSlot: '*:text-success-1'
            }
        },
        {
            palette: 'caution',
            emphasis: 'bold',
            class: {
                rootSlot: 'border-caution-7 bg-caution-7 text-caution-13',
                iconSlot: '*:text-caution-13'
            }
        },
        {
            palette: 'error',
            emphasis: 'bold',
            class: {
                rootSlot: 'border-error-9 bg-error-9 text-error-1',
                iconSlot: '*:text-error-1'
            }
        }
    ],
    defaultVariants: {
        emphasis: 'medium',
        palette: 'neutral',
        position: 'bottomRight'
    }
});
const toastPalettes = Object.keys(toastVariants.variants.palette);
const toastPositions = Object.keys(toastVariants.variants.position);
export { toastPalettes, toastPositions, toastVariants };
